import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "indicator"]
  
  connect() {
    this.currentIndex = 0
    this.showSlide(this.currentIndex)
  }
  
  next() {
    this.currentIndex = (this.currentIndex + 1) % this.slideTargets.length
    this.showSlide(this.currentIndex)
  }
  
  previous() {
    this.currentIndex = (this.currentIndex - 1 + this.slideTargets.length) % this.slideTargets.length
    this.showSlide(this.currentIndex)
  }
  
  goToSlide(event) {
    this.currentIndex = parseInt(event.currentTarget.dataset.index)
    this.showSlide(this.currentIndex)
  }
  
  showSlide(index) {
    // Hide all slides
    this.slideTargets.forEach(slide => {
      slide.classList.add('hidden')
    })
    
    // Show current slide
    this.slideTargets[index].classList.remove('hidden')
    
    // Update indicators
    this.indicatorTargets.forEach((indicator, i) => {
      if (i === index) {
        indicator.classList.remove('bg-gray-300')
        indicator.classList.add('bg-emerald-600')
      } else {
        indicator.classList.remove('bg-emerald-600')
        indicator.classList.add('bg-gray-300')
      }
    })
  }
}
